module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-three4.13cacc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-three4.png
// module id = c9bi
// module chunks = 0